import State from './state';

export function getCriterionList(state = State) {
  return (id) => {
    if (id in state.criterion_list) {
      return state.criterion_list[id];
    } else {
      return [];
    }
  };
}

export function getCriterionValues(state = State) {
  return (childId) => {
    if (childId in state.criterionValues) {
      return state.criterionValues[childId];
    } else {
      return [];
    }
  };
}

export function getAvailableDates(state = State) {
  return (childId) => {
    if (childId in state.availableDates) {
      return state.availableDates[childId];
    } else {
      return [];
    }
  };
}

export function getEditableDates(state = State) {
  return state.editableDates;
}

export function getCriterionToday(state = State) {
  return state.criterionToday;
}

export function getAllList(state = State) {
  return state.criterion_list;
}

export function getCriterionCategories(state = State) {
  return state.criterionCategories;
}

export function getCriterionImages(state = State) {
  return state.criterionImages;
}

export function getCriterionTimeFrequencyChoices(state = State) {
  return state.criterionTimeFrequencyChoices;
}

export function getCriterionTimeDayChoices(state = State) {
  return state.criterionTimeDayChoices;
}

export function getCriterionDaysOfWeek(state = State) {
  return state.criterionDaysOfWeek;
}
export function getPredefinedCriterion(state = State) {
  return state.predefinedCriterion;
}

export function getPossibleStarsToday(state = State) {
  return state.posibleStarsToday;
}

export function homeChallengeSkillId(state = State) {
  return state.home_challenge_skill_id;
}

export function getStarsEarned(state = State) {
  return state.starsEarned;
}
